module.exports = __webpack_public_path__ + "static/img/pro-img.556ad4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img.jpg
// module id = QNkg
// module chunks = 0